function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedGoldRibbonVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 195 249",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.04454,2.47702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: -3.045,
    y: -2.477,
    width: 194.796,
    height: 248.837,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11",
    serifId: "Artboard1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.133333,0,0,-0.133333,-232.205,567.843)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2404.96,2440.4L2159.85,2794.05L1759.78,2635.63L2032.58,3537.14L2677.76,3341.9L2404.96,2440.4",
    style: {
      fill: "rgb(169,34,49)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501.34,2446.55L2757.5,2792.28L3152.36,2621.31L2908.16,3530.98L2257.14,3356.22L2501.34,2446.55",
    style: {
      fill: "rgb(136,31,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2408.7,4213.7L2377.05,4105.6L2532.05,4105.6L2500.41,4213.7C2487,4259.51 2422.11,4259.51 2408.7,4213.7",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2506.7,4213.76L2455.74,4113.3L2608.11,4084.85L2596.85,4196.92C2592.07,4244.41 2528.29,4256.32 2506.7,4213.76",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603.04,4195.82L2534.51,4106.43L2679.06,4050.48L2688.56,4162.71C2692.59,4210.27 2632.08,4233.69 2603.04,4195.82",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694.45,4160.49L2610.67,4085.21L2742.49,4003.67L2772.44,4112.25C2785.14,4158.26 2729.95,4192.39 2694.45,4160.49",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2777.82,4108.99L2681.65,4050.36L2796.26,3946.01L2845.63,4047.25C2866.56,4090.14 2818.58,4133.83 2777.82,4108.99",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2850.32,4043.05L2745.02,4003.08L2838.52,3879.46L2905.64,3969.91C2934.09,4008.24 2894.94,4059.99 2850.32,4043.05",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2909.48,3964.93L2798.63,3944.97L2867.85,3806.28L2950.44,3882.87C2985.43,3915.33 2956.46,3973.38 2909.48,3964.93",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2953.29,3877.27L2840.66,3878L2883.24,3728.96L2978.49,3789.09C3018.85,3814.57 3001.02,3876.96 2953.29,3877.27",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2980.27,3783.05L2869.68,3804.45L2884.18,3650.13L2988.84,3691.75C3033.19,3709.38 3027.13,3773.99 2980.27,3783.05",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2989.48,3685.49L2884.71,3726.83L2870.62,3572.47L2981.15,3594.16C3027.99,3603.35 3033.88,3667.97 2989.48,3685.49",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2980.63,3587.89L2885.23,3647.76L2843.04,3498.62L2955.67,3499.65C3003.4,3500.08 3021.06,3562.52 2980.63,3587.89",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2954.01,3493.58L2871.22,3569.95L2802.37,3431.08L2913.28,3411.42C2960.27,3403.08 2989.09,3461.22 2954.01,3493.58",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910.53,3405.76L2843.17,3496.03L2749.99,3372.16L2855.4,3332.47C2900.07,3315.65 2939.07,3367.5 2910.53,3405.76",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2851.66,3327.41L2802.02,3428.52L2687.68,3323.86L2784.02,3265.49C2824.83,3240.76 2872.7,3284.57 2851.66,3327.41",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2779.41,3261.2L2749.17,3369.7L2617.57,3287.82L2701.55,3212.75C2737.13,3180.95 2792.22,3215.23 2779.41,3261.2",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2696.23,3209.38L2686.43,3321.59L2542.03,3265.26L2610.8,3176.06C2639.94,3138.26 2700.39,3161.84 2696.23,3209.38",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2604.95,3173.72L2615.92,3285.82L2463.63,3256.96L2514.85,3156.64C2536.56,3114.14 2600.31,3126.22 2604.95,3173.72",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2508.68,3155.42L2540.04,3263.6L2385.04,3263.19L2416.97,3155.18C2430.51,3109.41 2495.39,3109.58 2508.68,3155.42",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410.68,3155.11L2461.37,3255.69L2308.93,3283.75L2320.49,3171.7C2325.39,3124.23 2389.2,3112.48 2410.68,3155.11",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2308.19,3164.79L2382.59,3262.36L2237.89,3317.92L2227.86,3195.64C2224.2,3151 2281.04,3129.18 2308.19,3164.79",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2215.33,3201.13L2306.37,3283.38L2174.33,3364.56L2142.02,3246.2C2130.23,3202.99 2182.09,3171.1 2215.33,3201.13",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.71,3253.89L2235.3,3318.03L2120.41,3422.08L2066.92,3311.66C2047.4,3271.35 2092.53,3230.48 2130.71,3253.89",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.21,3321.3L2171.81,3365.15L2077.97,3488.52L2005.12,3389.8C1978.52,3353.76 2015.38,3305.3 2057.21,3321.3",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1997.34,3401.06L2118.04,3423.12L2048.45,3561.62L1958.71,3477.95C1925.95,3447.41 1953.29,3393 1997.34,3401.06",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.14,3490.45L2075.83,3489.97L2032.85,3638.9L1929.28,3573.13C1891.47,3549.12 1908.35,3490.62 1953.14,3490.45",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926.09,3586.43L2046.61,3563.44L2031.71,3717.72L1917.82,3672.09C1876.24,3655.43 1882.1,3594.82 1926.09,3586.43",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.13,3685.75L2031.38,3641.03L2045.06,3795.42L1924.72,3771.47C1880.8,3762.73 1875.42,3702.08 1917.13,3685.75",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926.55,3785.03L2030.65,3720.09L2072.44,3869.35L1949.75,3867.9C1904.97,3867.37 1888.56,3808.74 1926.55,3785.03",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954.05,3880.89L2044.45,3797.94L2112.93,3936.99L1992.07,3958.09C1947.95,3965.79 1921.05,3911.17 1954.05,3880.89",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.67,3970.07L2072.31,3871.94L2165.16,3996.05L2050.22,4038.98C2008.26,4054.65 1971.79,4005.9 1998.67,3970.07",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2058.91,4049.55L2113.28,3939.56L2227.33,4044.52L2122.23,4107.82C2083.87,4130.93 2039.06,4089.7 2058.91,4049.55",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.71,4116.61L2165.97,3998.51L2297.35,4080.75L2205.66,4162.27C2172.19,4192.03 2120.58,4159.72 2132.71,4116.61",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.58,4168.99L2228.58,4046.79L2372.83,4103.5L2297.66,4200.47C2270.23,4235.87 2213.56,4213.59 2217.58,4168.99",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2309.66,4194.88L2299,4082.75L2451.21,4112.01L2399.72,4212.19C2377.9,4254.64 2314.18,4242.39 2309.66,4194.88",
    style: {
      fill: "rgb(220,49,52)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2937.6,3681.64C2937.6,3414.86 2721.34,3198.59 2454.55,3198.59C2187.77,3198.59 1971.5,3414.86 1971.5,3681.64C1971.5,3948.42 2187.77,4164.69 2454.55,4164.69C2721.34,4164.69 2937.6,3948.42 2937.6,3681.64",
    style: {
      fill: "rgb(234,162,48)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2946.68,3681.64C2946.68,3414.86 2730.41,3198.59 2463.63,3198.59C2196.85,3198.59 1980.58,3414.86 1980.58,3681.64C1980.58,3948.42 2196.85,4164.69 2463.63,4164.69C2730.41,4164.69 2946.68,3948.42 2946.68,3681.64",
    style: {
      fill: "rgb(234,162,48)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2863.51,3681.64C2863.51,3455.78 2680.42,3272.68 2454.55,3272.68C2228.69,3272.68 2045.59,3455.78 2045.59,3681.64C2045.59,3907.5 2228.69,4090.6 2454.55,4090.6C2680.42,4090.6 2863.51,3907.5 2863.51,3681.64",
    style: {
      fill: "rgb(250,186,80)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedGoldRibbonVector);
export default __webpack_public_path__ + "static/media/red-gold-ribbon-vector.a9ee3cdc8d1372e609390cdddb9c602d.svg";
export { ForwardRef as ReactComponent };